module.exports = __webpack_public_path__ + "static/media/benefit_1.54b8c20a.JPG";